import {
  Row,
  Col,
  Form,
  Input,
  DatePicker,
  Radio,
  Flex,
  Switch,
  Button
} from 'antd'
import { FormInstance } from 'antd/lib'
import { t } from 'i18next'

import { IDNP_REGEX } from 'src/app-constants'
import { requiredRules, Text } from 'src/components/'
import {
  dayMonthYearBackSlash,
  disableLegalAgeDate,
  legalAgePickerValue
} from 'src/libs'

import { useStyles } from './styles'

type Props = {
  isDisabled: boolean
  isEditPage: boolean
  onResetPassword: () => void
  form: FormInstance
}

export const FormFields = ({
  isDisabled,
  isEditPage,
  onResetPassword,
  form
}: Props) => {
  const { styles } = useStyles()

  const status = Form.useWatch('status', form)

  return (
    <Row gutter={[24, 24]} className={styles.form}>
      <Col xs={24} md={12} xl={8}>
        <Form.Item
          label={t('form.last_name')}
          name="lastName"
          rules={requiredRules}
        >
          <Input disabled={isDisabled} placeholder={t('form.last_name')} />
        </Form.Item>
      </Col>

      <Col xs={24} md={12} xl={8}>
        <Form.Item
          label={t('form.first_name')}
          name="firstName"
          rules={requiredRules}
        >
          <Input disabled={isDisabled} placeholder={t('form.first_name')} />
        </Form.Item>
      </Col>

      <Col xs={24} md={12} xl={8}>
        <Form.Item
          name="idnp"
          label={t('form.idnp')}
          rules={requiredRules?.concat({
            pattern: IDNP_REGEX,
            message: t('form.idnp_error')
          })}
        >
          <Input disabled={isDisabled} placeholder={t('form.idnp')} />
        </Form.Item>
      </Col>

      <Col xs={24} md={12} xl={8}>
        <Form.Item
          name="dateOfBirth"
          label={t('form.birth_date')}
          rules={requiredRules}
        >
          <DatePicker
            disabled={isDisabled}
            className="full-width"
            placeholder={t('form.birth_date')}
            disabledDate={disableLegalAgeDate}
            defaultPickerValue={legalAgePickerValue}
            format={dayMonthYearBackSlash}
          />
        </Form.Item>
      </Col>

      <Col xs={24} md={12} xl={8}>
        <Form.Item
          name="email"
          label={t('form.email')}
          rules={[{ type: 'email' }]}
        >
          <Input placeholder={t('form.email')} />
        </Form.Item>
      </Col>

      <Col xs={24} md={12} xl={8}>
        <Form.Item name="phoneNumber" label={t('form.contact_number')}>
          <Input placeholder={t('form.contact_number')} />
        </Form.Item>
      </Col>

      <Col span={8}>
        <Form.Item name="gender" label={t('form.gender')} rules={requiredRules}>
          <Radio.Group disabled={isDisabled}>
            <Radio value="male">{t('form.male')}</Radio>
            <Radio value="female">{t('form.female')}</Radio>
          </Radio.Group>
        </Form.Item>
      </Col>

      <Col span={8}>
        <Flex align="flex-start">
          <Form.Item
            name="status"
            label={t('form.status')}
            valuePropName="checked"
          >
            <Switch />
          </Form.Item>

          <Text>({status ? t('common.active') : t('common.inactive')})</Text>
        </Flex>
      </Col>

      {isEditPage && (
        <Col span={8}>
          <Flex vertical align="flex-start" gap={8}>
            <Text>{t('form.password')}</Text>
            <Button onClick={onResetPassword}>
              {t('auth.reset_password')}
            </Button>
          </Flex>
        </Col>
      )}
    </Row>
  )
}
